import { render, staticRenderFns } from "./McBanner.vue?vue&type=template&id=24e1272c&scoped=true&"
import script from "./McBanner.vue?vue&type=script&lang=js&"
export * from "./McBanner.vue?vue&type=script&lang=js&"
import style0 from "./McBanner.vue?vue&type=style&index=0&id=24e1272c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24e1272c",
  null
  
)

export default component.exports